import { Column, Row } from 'components/Blocks';
import { WarningIcon } from 'components/Icons';
import { ReactNode } from 'react';

interface InlineAlertProps {
  children?: never;
  title: ReactNode;
  description: ReactNode;
}

export function InlineAlert({ description, title }: InlineAlertProps) {
  return (
    <Column className="rounded-lg border border-warning bg-warning/5 p-5">
      <Row gap="2">
        <WarningIcon color="warning" />

        <p className="font-semibold">{title}</p>
      </Row>

      <span className="text-sm">{description}</span>
    </Column>
  );
}
